import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

const beep = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [0, 0.25].forEach((t) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.frequency.value = 880;
      g.gain.setValueAtTime(0.15, ctx.currentTime + t);
      g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + t + 0.2);
      o.connect(g).connect(ctx.destination);
      o.start(ctx.currentTime + t);
      o.stop(ctx.currentTime + t + 0.2);
    });
  } catch { /* audio not allowed yet */ }
};

export const useHelpAlerts = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState([]);
  const seen = useRef(null);
  const reload = useCallback(() => api.get("/help-requests").then(({ data }) => {
    if (seen.current) {
      data.filter((r) => !seen.current.has(r.request_id)).forEach((r) => {
        beep();
        toast.warning(`Demande d'aide — ${r.machine_name}`, {
          description: `${r.user ? `${r.user} : ` : ""}${r.text}`, duration: 30000,
          action: { label: "Voir", onClick: () => navigate("/app?help=1") },
        });
      });
    }
    seen.current = new Set(data.map((r) => r.request_id));
    setOpen(data);
  }).catch(() => {}), [navigate]);
  useEffect(() => { reload(); const t = setInterval(reload, 8000); return () => clearInterval(t); }, [reload]);
  return { open, reload };
};
